module.exports = __webpack_public_path__ + "img/smac-logo.9db58627.png";